<template>
  <div class="program-dropdown">
    <div class="col-3 field-label">{{label}}:</div>
    <div class="col-7 field-response">
        <select v-model="currentValue" class="form-select inner-select" :disabled="elementDisabled">
            <option :value="null" v-show="currentValueDefined">Please Select Program</option>
            <option :value="undefined" v-show="!currentValueDefined">Please Select Program</option>
            <template v-for="(vals, subject) in sortedValues" :key="subject">
              <option :value="'not a value'" class="subject-fake-option" disabled v-if="subject !== 'allsubjects'">{{subject}}</option>
              <option v-for="val in vals" :value="val.id" :key="val.id" :class="{highlight: val.name.toUpperCase().includes(search)}" class="program-option">&nbsp;&nbsp;&nbsp;{{val.name}}</option>
            </template>
        </select>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'

export default {
  name: 'ProgramDropDown',
  mixins: [PropsMixin, ComputedMixin],
  props: ['programSearch', 'subjects'],
  data () {
    return {
    }
  },
  computed: {
    values () {
      return this.currentCampus ? this.formField.formListItems.filter((program) => !program.campus_ids || program.campus_ids.includes(this.currentCampus)) : this.formField.formListItems
    },
    sortedValues () {
      const sortAlphabetical = (a, b) => {
        var nameA = a.name.toUpperCase()
        var nameB = b.name.toUpperCase()
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
      }
      var sortedValues = {}
      if (this.subjects && this.subjects.length > 0) {
        var sortedSubs = this.subjects
        sortedSubs.sort(sortAlphabetical)
        sortedSubs.forEach((subject) => {
          sortedValues[subject.name] = this.values.filter((v) => v.subject_id === subject.id)
          sortedValues[subject.name].sort(sortAlphabetical)
        })
        return sortedValues
      }
      sortedValues = this.values ?? []
      sortedValues.sort(sortAlphabetical)
      return { allsubjects: sortedValues }
    },
    search () {
      return this.programSearch ? this.programSearch.toUpperCase() : null
    }
  },
  mounted () {
  },
  watch: {
    values (newValues) {
      if (!newValues.some(v => v.id === this.currentValue)) {
        this.currentValue = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
option.highlight {
  background: #4cae4c;
  color: white;
}
.subject-fake-option {
  font-size: 14px;
}
</style>
